import bannerLinks from 'utils/banner_links';

angular.module('wbServices').factory 'sharedLinks',
[ '$window', ($window) ->
  @banner = bannerLinks
  @
]
